import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const BulkCreateProgramWrapper = styled.div`
  .MuiTabs-root {
    display: none;
  }

  .accordion-header {
    margin-top: 16px;

    ${responsive.MOBILE`
      &:first-of-type {
        margin-top: 24px;
      }

      &:nth-of-type(2) {      
        .MuiPaper-root {
          background-color: transparent;

          .MuiCollapse-root {
            background-color: ${COLORS.cirrus_white};
            margin-top: 8px;
          }
        }
      }
    `}
  }

  .header-back {
    margin-top: 16px;
    height: 16px;
    svg {
      width: 18px;
      height: 16px;
      margin-left: 16px;
    }
  }
  .form-container {
    padding: 0px 0px 16px 16px;
  }
  .form-field {
    padding-right: 16px;
  }

  .footer-close-btn {
    justify-content: flex-end;
    ${responsive.MOBILE`
      padding: 16px 0px;
    `}
  }
`;

export const InformationWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
    line-height: 22px;
  }
`;
